import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import FooterV2 from '../Footer/FooterV2';
import Header from '../Header';
import ModalBS from '../../../containers/ModalBS';
import TickerPrice from '../../../containers/Tickers/TickerPrice';
import TickerPower from '../../../containers/Tickers/TickerPower';
import ReminderBS from '../../../containers/ReminderBS';
import ErrorBoundary from '../../../containers/ErrorBoundary';

class PageLayoutFree extends PureComponent {
  render(){
    return(
      <ErrorBoundary>
      <div className='bs-body-free'>
        <ReminderBS />
        <ModalBS />
        { this.props.price ? <TickerPrice /> : null }
        { this.props.power ? <TickerPower /> : null }
          <h6 className='bs-subtitle no-margin error invalid-pin'>{this.props.errorMessage}</h6>
          <div className="bs-container">
            {this.props.children}
          </div>
        <FooterV2 showPhone={this.props.showPhone}/>
      </div>
      </ErrorBoundary>
    )
  }
}

PageLayoutFree.defaultProps={
  showPhone: true,
  errorMessage: '',
  header: true
}

function mapStateToProps(state){
  return{
    maintenance: state.maintenance
  }
}

export default connect(mapStateToProps)(PageLayoutFree);